import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import buddy from '../../TDD-Images/buddysteppingstone.png'
import { useAppContext } from "../appContext";
import { Check } from "@mui/icons-material";
import { SessionQuestion } from "@/utils/types";
import Nav from "./nav";



const AssessmentCompletePage = () => {

  const {state, navigateThenRun} =
    useAppContext();

  const navigate = useNavigate();

  return (
    <>
    <Nav/>
    <div className='full-nav'>
      <div className="dashboardScreen">
        <div className='dashboardContent'>
          <div className="flex-col w-[100%] items-start">
            <div className="flex-col items-start">
              <p className="text-customBlack text-lg mb-3">{`Nice work, ${state.profileUser?.name.split(' ')[0] || ""}`}</p>
              <div className="flex justify-between w-[100%]">
                <p className="font-bold text-grayBlue text-5xl">You've completed the assessment!</p>
              </div>
              {/* <p className="text-customBlack text-lg mt-4 w-[65%] text-left">Great job, you're well on your way to landing the role of your dreams.</p> */}
              <div className="mt-4 flex items-start">
                <img src={buddy} className="buddy mt-5" alt="buddy" />
                <div className="flex-col gap-3 shadow-sm mb-5 ml-2 p-3 bg-white w-[65%]">

                  <div className='text-left w-[100%]'>
                    <div className=""><p className='mr-5 text-grayBlue text-2xl mb-1' >Great job</p>
                      <p className='text-customBlack mb-2'>You're well on your way to landing the role of your dreams.</p>
                      <div className='flex justify-start gap-2'>
                        <div className='px-3 py-2 cursor-pointer text-white font-[300] hover:bg-orangeButton-hover bg-orangeButton rounded-md shadow-sm' onClick={() => navigateThenRun(null, "/")}><p>Keep Practicing on The Dev Difference</p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-col align-self-start self-start">
                <p className="mt-2 mb-4 text-grayBlue font-bold">Here's a review of the questions</p>
              </div>
              {state.session.map((question: SessionQuestion, index: number) => {
                return (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 mb-4 bg-white shadow-md rounded-lg w-full max-w-4xl mx-auto"
                  >
                    <div className="text-gray-800 font-medium">
                      {index + 1}. {question.question.question}
                    </div>
                    {question.prompt.length > 0 && (
                      <Check
                        sx={{marginLeft:"1rem", color: "green", fontSize: "1.5rem" }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AssessmentCompletePage;